<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="0" stepTitle="图文详情及价格"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">基础信息</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="商品标题" prop="proName">
              <a-input v-model="ruleForm.proName" :maxLength="120" placeholder="请输入">
                <span slot="addonAfter">{{ ruleForm.proName.length }}/120</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="介绍标语" prop="proTitle">
              <a-textarea v-model="ruleForm.proTitle" :maxLength="120" placeholder="请输入"
                          :auto-size="{ minRows: 3, maxRows: 5 }"/>
            </a-form-model-item>
            <a-form-model-item label="目的地" prop="destination">
              <AreaKinkage
                v-model="ruleForm.destination"
                ref="areaData1"
                @getAreaData="getDesAreaData" :isshow="false" maxWidth="600px"></AreaKinkage>
            </a-form-model-item>
            <a-form-model-item label="证件类型" prop="tourCardList">
              <a-checkbox-group
                v-model="ruleForm.tourCardList"
                name="checkboxgroup"
                :options="plainOptions"
              />
            </a-form-model-item>
            <a-form-model-item label="出发地" prop="departure">
              <AreaKinkage
                v-model="ruleForm.departure"
                ref="areaData2"
                @getAreaData="getDepAreaData" :isshow="false" maxWidth="600px"></AreaKinkage>
            </a-form-model-item>
            <a-form-model-item label="去程交通" prop="tourGoMode">
              <a-select v-model="ruleForm.tourGoMode" allowClear placeholder="请选择" style="max-width:600px;">
                <a-select-option v-for="item in trafficArr" :key="item.value" :value="item.value">{{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="回程交通" prop="tourBackMode">
              <a-select v-model="ruleForm.tourBackMode" allowClear placeholder="请选择" style="max-width:600px;">
                <a-select-option v-for="item in trafficArr" :key="item.value" :value="item.value">{{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="商品轮播图" prop="proImgs">
              <custom-upload-pro-images v-model="ruleForm.proImgs"
                                        :pro-id="proId" :multiple-selected="true"
                                        :draggableUpdate="true">
              </custom-upload-pro-images>
            </a-form-model-item>
            <a-form-model-item label="行程天数" prop="tourDay">
              <a-input v-model="ruleForm.tourDay" :maxLength="20" style="max-width:600px;"
                       placeholder="请输入行程天数"></a-input>
            </a-form-model-item>
            <a-card :bordered="false" :bodyStyle="{padding:'0px'}" :headStyle="{borderBottom:'0px',padding:'0px'}">
              <a-row slot="title">
                <a-col :span="8">
                  <span class="card-title">行程信息</span>
                </a-col>
              </a-row>
              <a-row v-for="(item, index) in ruleForm.proTourRoutes" :key="index">
                <a-form-model-item
                  :label-col="index === 0 ? currentFormLayout.labelCol : {}"
                  :wrapper-col="index === 0 ?currentFormLayout.wrapperCol:currentFormLayout.offsetCol"
                  :label="index === 0 ? '行程标题' : ''"
                  :prop="'proTourRoutes.' + index + '.tourRouteTitle'"
                  :rules="[{ required: true, message: '请输入行程标题', trigger: 'blur',},
                  { max: 100, message: '不能超过100个字符', trigger: 'blur' }]"
                >
                  <a-input v-model="item.tourRouteTitle" style="max-width:600px;" placeholder="请输入行程标题"/>
                  <a-icon
                    v-if="ruleForm.proTourRoutes.length > 1"
                    class="dynamic-delete-button"
                    type="minus-circle-o"
                    :disabled="ruleForm.proTourRoutes.length === 1"
                    @click="removeDomain(item)"
                  />
                </a-form-model-item>
                <a-form-model-item :label-col="index === 0 ? currentFormLayout.labelCol : {}"
                                   :wrapper-col="index === 0 ?currentFormLayout.wrapperCol:currentFormLayout.offsetCol"
                                   :label="index === 0 ? '行程描述' : ''"
                                   :prop="'proTourRoutes.' + index + '.tourRouteDesc'"
                                   :rules="[{ required: true, message: '行程描述不能为空', trigger: 'blur',}]">
                  <div>如果上传本地图片，图片大小应小于1M，图片格式为.jpg .png</div>
                  <!-- 百度富文本 -->
                  <div style="max-width:800px;">
                    <vue-ueditor-wrap v-model="item.tourRouteDesc" :config="myConfig"
                                      :destroy="true"></vue-ueditor-wrap>
                  </div>
                </a-form-model-item>
              </a-row>
              <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
                <a-button type="dashed" @click="addDomain">
                  <a-icon type="plus"/>
                  添加行程
                </a-button>
              </a-form-model-item>
            </a-card>
            <a-form-model-item label="费用包含">
              <a-textarea v-model="ruleForm.tourFeeContain" :maxLength="5000" placeholder="请输入"
                          :auto-size="{minRows:5,maxRows:15}"/>
            </a-form-model-item>
            <a-form-model-item label="费用不包含">
              <a-textarea v-model="ruleForm.tourFeeNotContain" :maxLength="5000" placeholder="请输入"
                          :auto-size="{minRows:5,maxRows:15}"/>
            </a-form-model-item>
            <a-form-model-item label="参加须知">
              <a-textarea v-model="ruleForm.tourJoinNotice" :maxLength="5000" placeholder="请输入"
                          :auto-size="{minRows:5,maxRows:15}"/>
            </a-form-model-item>
            <a-form-model-item label="出行须知">
              <a-textarea v-model="ruleForm.tourGoNotice" :maxLength="5000" placeholder="请输入"
                          :auto-size="{minRows:5,maxRows:15}"/>
            </a-form-model-item>
            <a-form-model-item label="重要提示">
              <a-textarea v-model="ruleForm.tourTips" :maxLength="5000" placeholder="请输入"
                          :auto-size="{minRows:5,maxRows:15}"/>
            </a-form-model-item>
            <a-form-model-item label="发票模板" prop="invoiceTemplateId">
              <InvoiceSelect ref="InvoiceSelect" :proId="proId" :catalogId="catalogId"
                             v-model="ruleForm.invoiceTemplateId"></InvoiceSelect>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">
                提交并下一步
              </a-button>
              <a-button v-if="proId!=0" @click="goEvent" style="margin-left: 10px">下一步</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-card>

      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import AreaKinkage from '@/customComponents/AreaKinkage/AreaKinkage'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'
import VueUeditorWrap from 'vue-ueditor-wrap'
import InvoiceSelect from '../components/InvoiceSelect'

export default {
  name: 'TravelBasicInfo',
  components: {
    ProductHeader,
    PublishHelper,
    AreaKinkage,
    CustomUploadProImages,
    VueUeditorWrap,
    InvoiceSelect
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      ruleForm: {
        proId: this.$route.query.proId,
        proImgs: [], //自有行图片
        proName: '', //产品名称
        proTitle: '', //介绍标语
        proTourRoutes: [
          {
            tourRouteDesc: '', //富文本
            tourRouteTitle: '', //标题
            tourRouteId: 0,
            tourProductId: '',
            tourRouteImage: ''
          }
        ],
        tourBackMode: undefined, //回程交通
        tourCardList: [], //证件类型集合
        tourDay: '', //行程天数 ,
        tourFeeContain: '', //费用包含
        tourFeeNotContain: '', // 费用不包含
        tourGoMode: undefined, //去程交通
        tourGoNotice: '', //出行须知 ,
        tourArriveCityId: '', //目的城市ID
        tourArriveProvinceId: '', //目的省份ID
        tourId: '', //表Id ,
        tourJoinNotice: '', //参加须知
        tourTips: '', //重要提示
        tourToCity: '', //目的地
        proProvinceId: '',
        proCityId: '',
        proCountyId: '', //出发区域ID
        tourArriveCountyId: '', //目的地id
        destination: undefined,
        departure: undefined,
        invoiceTemplateId: undefined//发票
      },
      submitLoading: false,
      submitFormData: '',
      invoiceTemplateList: [],
      rules: {
        proName: [
          { required: true, message: '请输入商品标题', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入介绍标语', trigger: 'blur' }
        ],
        destination: [
          { required: true, message: '请选择目的地', trigger: 'change' }
        ],
        departure: [
          { required: true, message: '请选择出发地', trigger: 'change' }
        ],
        tourCardList: [
          { type: 'array', required: true, message: '请选择证件类型', trigger: 'change' }
        ],
        tourGoMode: [
          { required: true, message: '请选择去程交通', trigger: 'change' }
        ],
        tourBackMode: [
          { required: true, message: '请选择返程交通', trigger: 'change' }
        ],
        proImgs: [
          { required: true, message: '请选择图片', trigger: ['blur', 'change'] }
        ],
        tourDay: [
          { required: true, message: '请填写行程天数', trigger: 'blur' },
          { pattern: /^[1-9]\d{0,2}$/, message: '请输入正确的天数', trigger: 'blur' }
        ],
        invoiceTemplateId: [
          { required: true, message: '请选择发票模板', trigger: 'change' }
        ]
      },
      fileList: [],
      imageList: [],
      plainOptions: [
        {
          value: '1',
          label: '身份证'
        },
        {
          value: '2',
          label: '护照'
        },
        {
          value: '3',
          label: '港澳通行证'
        },
        {
          value: '4',
          label: '台湾通行证'
        },
        {
          value: '5',
          label: '军官证'
        },
        {
          value: '6',
          label: '台胞证'
        },
        {
          value: '7',
          label: '回乡证'
        },
        {
          value: '8',
          label: '户口簿'
        },
        {
          value: '9',
          label: '出生证明'
        }
      ],
      trafficArr: [
        {
          value: 1,
          label: '飞机'
        },
        {
          value: 2,
          label: '火车'
        },
        {
          value: 3,
          label: '汽车'
        },
        {
          value: 4,
          label: '轮船'
        },
        {
          value: 5,
          label: '动车'
        },
        {
          value: 6,
          label: '高铁'
        },
        {
          value: 8,
          label: '快艇'
        },
        {
          value: 7,
          label: '自理'
        }
      ],
      myConfig: {
        // 如果需要上传功能,找后端小伙伴要服务器接口地址
        // serverUrl: this.$config.baseUrl + 'ueditor/ueditorConfig',
        serverUrl: this.getFwbFileUrl(),
        // 你的UEditor资源存放的路径,相对于打包后的index.html
        UEDITOR_HOME_URL: '/UEditor/',
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 工具栏是否可以浮动
        autoFloatEnabled: false,
        // 初始容器高度
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 关闭自动保存
        enableAutoSave: true
      }
    }
  },
  mounted() {
    this.getProductInfo()
  },
  methods: {
    //获取富文本上传地址
    getFwbFileUrl() {
      let appConfig = this.getAppConfig()
      this.getLogUtils().logWithTag('getFwbFileUrl', appConfig)
      return appConfig.fwbUrl
    },
    // 获取城市出发地id
    getDepAreaData(data) {
      this.ruleForm.departure = data
      if (data && data.length > 0) {
        this.ruleForm.proProvinceId = data[0]
        this.ruleForm.proCityId = data[1]
      }
      this.getLogUtils().logWithTag('getDepAreaData', this.ruleForm.departure)
    },
    // 获取城市目的地id
    getDesAreaData(data) {
      this.ruleForm.destination = data
      if (data && data.length > 0) {
        this.ruleForm.tourArriveProvinceId = data[0]
        this.ruleForm.tourArriveCityId = data[1]
      }
      this.getLogUtils().logWithTag('getDesAreaData', this.ruleForm.destination)
    },
    addDomain() {
      this.ruleForm.proTourRoutes.push({
        tourRouteTitle: '', //标题
        tourRouteId: 0,
        tourRouteImage: '',
        tourRouteDesc: '',
        tourProductId: ''
      })
    },
    removeDomain(item) {
      let index = this.ruleForm.proTourRoutes.indexOf(item)
      if (index !== -1) {
        this.ruleForm.proTourRoutes.splice(index, 1)
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitFormData.proImgs = this.submitFormData.proImgs.length > 0 ? this.submitFormData.proImgs.join(',') : ''
      this.submitFormData.tourCardList = this.submitFormData.tourCardList.join(',')
      delete this.submitFormData.destination
      delete this.submitFormData.departure
      this.getHttpServices().getProService().post('tour/saveTour', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('自由行基础信息保存成功')
        this.ruleForm.proId = res
        this.$router.push({
          name: 'TravelProDes',
          query: {
            proId: this.ruleForm.proId,
            catalogId: this.catalogId,
            proSource: this.proSource,
            isBack: this.proId == 0 ? 1 : undefined
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    goEvent() {
      this.$router.push({
        name: 'TravelProDes',
        query: {
          proId: this.proId,
          catalogId: this.catalogId,
          proSource: this.proSource
        }
      })
    },
    // 获取基本信息
    getProductInfo() {
      if (this.proId != 0) {
        this.getHttpServices().getProService().get('tour/getTourByProId/' + this.proId).then(res => {
          this.getLogUtils().logWithTag('getProductInfo', res)
          this.ruleForm = res
          if (res.tourArriveProvinceId && res.tourArriveCityId) {
            this.ruleForm.destination = [res.tourArriveProvinceId, res.tourArriveCityId]
            this.$refs.areaData1.getArea(this.ruleForm.destination)
          }
          if (res.proProvinceId && res.proCityId) {
            this.ruleForm.departure = [res.proProvinceId, res.proCityId]
            this.$refs.areaData2.getArea(this.ruleForm.departure)
          }
          this.ruleForm.tourCardList = res.tourCardList ? res.tourCardList.split(',') : []

          this.ruleForm.proImgs = res.proImgs && res.proImgs != '' ? res.proImgs.split(',') : []
          this.$refs.InvoiceSelect.getMatchTemplateId()
          this.getLogUtils().logWithTag('getProductInfo', this.ruleForm)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  left: 5px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
<style>
.edui-default .edui-editor-toolbarbox {
  line-height: normal;
}
</style>